import {useQuery} from '@apollo/client';
import {useEffect, useState} from 'react';
import {
    GET_SORTER_SORTING_LOG_LISTING,
    SorterSortingLogFiltersInput,
    SorterSortingLogListingResponse,
    SorterSortingLogType,
} from '../graphql/queries/getSorterSortingLogListing';

export const useSorterSortingLogQuery = (
    filters: SorterSortingLogFiltersInput,
    currentPage: number,
    pageSize: number
) => {
    const [data, setData] = useState<SorterSortingLogType[]>([]);
    const [totalElements, setTotalElements] = useState(0);

    const {data: queryData, loading, refetch} = useQuery<SorterSortingLogListingResponse>(
        GET_SORTER_SORTING_LOG_LISTING,
        {
            variables: {
                filters,
                pageRequest: {page: currentPage, size: pageSize},
            },
            fetchPolicy: 'cache-and-network',
        }
    );

    useEffect(() => {
        if (queryData?.getSorterSortingLogListing) {
            setData(queryData.getSorterSortingLogListing.content || []);
            setTotalElements(
                parseInt(queryData.getSorterSortingLogListing.totalElements.toString()) || 0
            );
        }
    }, [queryData]);

    return {data, loading, totalElements, refetch};
};
